import styled, { css } from 'styled-components';

import Bullet from '../_Bullet';
const RADIO_SIZE = 20;

export const StyledHiddenRadioButton = styled.input`
  opacity: 0;
  position: absolute;
  width: ${RADIO_SIZE}px;
  height: ${RADIO_SIZE}px;
  z-index: 1;  
  cursor: pointer;

  ${({ disabled }) => (disabled) && css`
    cursor: default;
  `}
`;

export const StyledRadioButtonWrapper = styled.span<{
  disabled?: boolean;
  readOnly?: boolean;
}>`
  position: relative;
  width: ${RADIO_SIZE}px;
  height: ${RADIO_SIZE}px;
  display: inline-block;

  &:hover {
    ${({ disabled, readOnly }) => !disabled && !readOnly && css`
      ${Bullet.StyledBullet} {
          border-color: ${({ theme }) => theme?.RadioButton?.hoverOutlineColor};
      }
    `}
  }
`;
